<template>
  <div>
    <nav-item
      icon="fa fa-user"
      label="Users"
      description="Invite, edit, and delete users"
      :to="`/admin/accounts/${accountId}/users`"
    />
    <nav-item
      v-if="isServiceProvider"
      icon="fa fa-building"
      label="Law Firms"
      description="View law firms"
      :to="`/admin/accounts/${accountId}/customers`"
    />
    <nav-item
      v-if="isCustomer"
      icon="fa fa-address-book"
      label="Clients"
      description="Manage law firm clients"
      :to="`/admin/accounts/${accountId}/clients`"
    />
    <nav-item
      v-if="isCustomer && isGranted('VIEW_PAYMENT_METHODS')"
      icon="fa fa-receipt"
      label="Billing"
      description="View payment methods & receipts"
      :to="`/admin/accounts/${accountId}/billing`"
    />
    <nav-item
      v-if="isCustomer && isGranted('VIEW_POST')"
      icon="fa fa-trash"
      label="Trash"
      description="Restore deleted posts"
      :to="`/admin/accounts/${accountId}/trash`"
    />
    <q-separator />
    <nav-item
      v-if="isCustomer && isGranted('VIEW_SERVICE_ACCOUNTS') && hasFeat('INTEGRATIONS')"
      icon="fa fa-plug"
      label="Integrations"
      description="Connect third-party services"
      :to="`/admin/accounts/${accountId}/integrations`"
    />
    <account-loader :account-id="accountId" v-model="account" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AccountLoader from '@/iam/account/AccountLoader.vue';
import { Account } from '@/iam/types';
import { AccountType } from '@/iam/account';
import isGranted from '@/auth/isGranted';
import { hasFeat } from '@/iam/config';
import NavItem from './NavItem.vue';

interface Data {
  account?: Account
}
export default defineComponent({
  components: {
    AccountLoader,
    NavItem,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
  data(): Data {
    return {
      account: undefined,
    };
  },
  computed: {
    isServiceProvider(): boolean {
      return this.account ? AccountType.isServiceProvider(this.account.type) : false;
    },
    isCustomer(): boolean {
      return this.account ? AccountType.isCustomer(this.account.type) : false;
    },
  },
  methods: {
    isGranted,
    hasFeat,
  },
});
</script>
